import '../../styles/bitacora.style.css'
import {useDispatch, useSelector} from 'react-redux'
import BasicCardDocumentos from '../DatosDeCierre/BasicCardDocumentos'
import ModalCargarFileCompras from '../LibroCompras/ModalCargarFileCompras'
import { State } from '../../../../reducers'
import { useHistory } from 'react-router'
import { useEffect, useState } from 'react'
import { Pagination } from '../../../../components/Pagination';
import { postCargarLibrosCompras } from '../../../../actions/libros/libro-compras.actions'
import FilterButton from '../../../../components/Tables/TableComponent/FilterButton'
import { generalOpenToastError } from '../../../../actions/general.actions'

import { PanelClasificacionCompras, SelectClasificacion } from '../LibroCompras/PanelClasificacionCompras'
import { CAMPOS_CODIGO, CampoCodigo, Codigos, calcularAplicacion, esCodigoValido, mensajeAplicacion, periodoExigeClasificacion } from '../../../../utils/codificacion-compras.utils'

const TableDataCargadaCompras = () => {
  const {comprasFileDataCargada} = useSelector((state: State) => state.libros);
  const {dataFile, form, fileBase64} = comprasFileDataCargada;

  const [modalCargarFile, setModalCargarFile] = useState<boolean> (false);
  const [currentItems, setCurrentItems] = useState<Array<any>>([]);
  const [sortedArray, setSortedArray] = useState<Array<any>>([]);
  // Clasificacion editada por documento (clave: numCorrelativo)
  const [codigos, setCodigos] = useState<Record<string, Partial<Codigos>>>({});

  const dispatch = useDispatch();
  const history = useHistory();

  // Desde febrero 2024 las 4 columnas son obligatorias (form.declaracion viene como AAAA-MM)
  const exigeCodificacion = periodoExigeClasificacion(form?.declaracion);

  const valorCodigo = (item: any, campo: CampoCodigo): number => Number(codigos[item.numCorrelativo]?.[campo] ?? item[campo] ?? 0) || 0;

  const handleCambioCodigo = (item: any, campo: CampoCodigo, valor: number) => {
    setCodigos((prev) => ({ ...prev, [item.numCorrelativo]: { ...prev[item.numCorrelativo], [campo]: valor } }));
  }

  // Aplica lo elegido en el panel a todas las compras o solo a las pendientes; devuelve el mensaje con el resultado
  const handleAplicar = (masivo: Codigos, soloSinClasificar: boolean): string => {
    const { parches, compras } = calcularAplicacion(dataFile, (item) => String(item.numCorrelativo), valorCodigo, masivo, soloSinClasificar);
    setCodigos((prev) => {
      const siguiente = { ...prev };
      Object.entries(parches).forEach(([clave, parche]) => { siguiente[clave] = { ...siguiente[clave], ...parche }; });
      return siguiente;
    });
    return mensajeAplicacion(compras);
  }

  const documentosSinCodificar = (): number => dataFile.filter((item: any) => CAMPOS_CODIGO.some((campo) => !esCodigoValido(campo, valorCodigo(item, campo)))).length;

  const handleCrearLibro = async () => {
    const pendientes = documentosSinCodificar();
    if (exigeCodificacion && pendientes > 0) {
      dispatch(generalOpenToastError(`Faltan ${pendientes} compras por clasificar. Complete tipo de operación, clasificación, sector y tipo de costo/gasto en cada una para poder confirmar.`));
      return;
    }
    // Se envian las filas con la clasificacion editada
    const datosHacienda = dataFile.map((item: any) => ({ ...item, ...codigos[item.numCorrelativo] }));
    if (await dispatch(postCargarLibrosCompras({ ...form, datosHacienda }, fileBase64))) {
      history.push('/mas-opciones/libro-compras');
    }
  }

  useEffect(() => {
    setSortedArray(currentItems);
  }, [currentItems]);

  return (
    <>
      { 
        modalCargarFile
        && <ModalCargarFileCompras onAccept={() => setModalCargarFile(false)} onClose={() => setModalCargarFile(false)} />
      }
      <div className="w-layout-layout bill-section wf-layout-layout">
        <BasicCardDocumentos 
          style={{boxShadow: 'none', padding: '0'}} 
          title="Validar datos" 
          size="l"
        >
          <div style={{display: 'flex', justifyContent: 'start', marginTop: '8px', marginBottom: '16px' }}>
            <button className="button w-auto" onClick={() => setModalCargarFile(true)}>Cargar nuevo libro de compras</button>
          </div>
          <PanelClasificacionCompras exige={exigeCodificacion} total={dataFile.length} pendientes={documentosSinCodificar()} onAplicar={handleAplicar} />
          <div className="tab-plane">
            <div className="table-facturacion-resp">
              <table className="table-main-responsive responsive-table-main td-left table-pointer">
                <thead>
                  <tr>
                    <td>No. <FilterButton keyName='numCorrelativo' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                    <td>Fecha Emisión <FilterButton keyName='fechaEmision' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                    <td>Número Comprobante <FilterButton keyName='numeroComprobante' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                    <td>NIT Provedor <FilterButton keyName='nitProveedor' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                    <td>Número Registro <FilterButton keyName='nrcProveedor' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                    <td>DUI Proveedor <FilterButton keyName='duiProveedor' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                    <td>Nombre Proveedor <FilterButton keyName='nombreProveedor' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                    
                    <td>Número Control <FilterButton keyName='numeroControl' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                    <td>Código Generación <FilterButton keyName='codigoGeneracion' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                    <td>Sello Recepción <FilterButton keyName='selloRecepcion' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                    <td>Tipo Operación <FilterButton keyName='tipoOperacion' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                    <td>Clasificación <FilterButton keyName='clasificacion' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                    <td>Tipo Costo/Gasto <FilterButton keyName='tipoClasificacion' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                    <td>Sector <FilterButton keyName='sector' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                    
                    <td>Exentas Locales <FilterButton keyName='exentasLocales' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                    <td>Exentas Importaciones <FilterButton keyName='exentasImportaciones' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                    <td>Exentas Internacionales <FilterButton keyName='exentasInternacionales' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                    <td>Gravadas Locales <FilterButton keyName='gravadasLocales' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                    <td>Gravadas Importaciones <FilterButton keyName='gravadasImportaciones' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                    <td>Gravadas Importaciones Servicios <FilterButton keyName='gravadasImportacionesServicios' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                    <td>Gravadas Internacionales <FilterButton keyName='gravadasInternacionales' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                    <td>Crédito Fiscal IVA <FilterButton keyName='creditoFiscalIva' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                    <td>Total Compras <FilterButton keyName='totalCompras' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                    <td>Percepción <FilterButton keyName='percepcion' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                    <td>Retención <FilterButton keyName='retencion' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                  </tr>
                </thead>
                <tbody>
                  {
                    sortedArray?.length > 0 && 
                    (
                      sortedArray.map((item: any) => (
                        <tr key={item.numCorrelativo}>
                          <td data-label='No.'>{item.numCorrelativo}</td>
                          <td data-label='Fecha Emisión'>{item.fechaEmision}</td>
                          <td data-label='Número Comprobante'>{item.numeroComprobante}</td>
                          <td data-label='NIT Proveedor'>{item.nitProveedor}</td>
                          <td data-label='Número Registro'>{item.nrcProveedor}</td>
                          <td data-label='DUI Proveedor'>{item.duiProveedor}</td>
                          <td data-label='Nombre Proveedor'>{item.nombreProveedor}</td>
                          
                          <td data-label='Número Control'>{item.numeroControl}</td>
                          <td data-label='Código Generación'>{item.codigoGeneracion}</td>
                          <td data-label='Sello Recepción'>{item.selloRecepcion}</td>
                          <td data-label='Tipo Operación'><SelectClasificacion campo='tipoOperacion' valor={valorCodigo(item, 'tipoOperacion')} exige={exigeCodificacion} onChange={(valor) => handleCambioCodigo(item, 'tipoOperacion', valor)} /></td>
                          <td data-label='Clasificación'><SelectClasificacion campo='clasificacion' valor={valorCodigo(item, 'clasificacion')} exige={exigeCodificacion} onChange={(valor) => handleCambioCodigo(item, 'clasificacion', valor)} /></td>
                          <td data-label='Tipo Costo/Gasto'><SelectClasificacion campo='tipoClasificacion' valor={valorCodigo(item, 'tipoClasificacion')} exige={exigeCodificacion} onChange={(valor) => handleCambioCodigo(item, 'tipoClasificacion', valor)} /></td>
                          <td data-label='Sector'><SelectClasificacion campo='sector' valor={valorCodigo(item, 'sector')} exige={exigeCodificacion} onChange={(valor) => handleCambioCodigo(item, 'sector', valor)} /></td>

                          <td data-label='Exentas Locales'>{parseFloat(item.exentasLocales).toFixed(2)}</td>
                          <td data-label='Exentas Importaciones'>{parseFloat(item.exentasImportaciones).toFixed(2)}</td>
                          <td data-label='Exentas Internacionales'>{parseFloat(item.exentasInternacionales).toFixed(2)}</td>
                          <td data-label='Gravadas Locales'>{parseFloat(item.gravadasLocales).toFixed(2)}</td>
                          <td data-label='Gravadas Importaciones'>{parseFloat(item.gravadasImportaciones).toFixed(2)}</td>
                          <td data-label='Gravadas Importaciones Servicios'>{parseFloat(item.gravadasImportacionesServicios).toFixed(2)}</td>
                          <td data-label='Gravadas Internacionales'>{parseFloat(item.gravadasInternacionales).toFixed(2)}</td>
                          <td data-label='Crédito Fiscal IVA'>{parseFloat(item.creditoFiscalIva).toFixed(2)}</td>
                          <td data-label='Total Compras'>{parseFloat(item.totalCompras).toFixed(2)}</td>
                          <td data-label='Percepción'>{parseFloat(item.percepcion).toFixed(2)}</td>
                          <td data-label='Retención'>{parseFloat(item.retencion).toFixed(2)}</td>
                        </tr>
                      ))
                    )
                  }
                </tbody>
              </table>
              {dataFile.length > 0 && (
                <Pagination
                  data={dataFile}
                  state={(items: Array<any>) => setCurrentItems(items)}
                  items={20}
                />
              )}
            </div>
            <div style={{display: 'flex', justifyContent: 'center', flexWrap: 'wrap', marginTop: '16px'}}>
              <button className="button w-auto" onClick={handleCrearLibro}>Confirmar datos</button>
            </div>
          </div>
        </BasicCardDocumentos>
      </div>
    </>
  )
}

export default TableDataCargadaCompras
